<div class="wiz-box">
  <div class="heading">{{'wizard.step-7.title' | translate}}</div>
  <div class="wiz-content">
    <p class="my-2 mb-3 text-muted">{{'wizard.step-7.import.p-1' | translate}}</p>

    <div class="num-item">
      <div class="num-item-top">
        <div class="num-item-num">1.</div>
        <p>
          {{'wizard.step-7.import.download.p-1' | translate}}
          <p-progressSpinner *ngIf="exportLoading; else link" class="small-spinner"></p-progressSpinner>
          <ng-template #link>
            <span class="link-red ml-1" (click)="downloadFile()">{{'wizard.step-7.import.download.p-2' | translate}}</span>
<!--            <a [href]="exportUrl" target="_blank">{{'wizard.step-7.import.download.p-2' | translate}}</a>-->
          </ng-template>
        </p>
      </div>
    </div>
    <div class="num-item">
      <div class="num-item-top">
        <div class="num-item-num">2.</div>
        <p>
          {{'wizard.step-7.fulfill' | translate}}
        </p>
      </div>
    </div>
    <div class="num-item">
      <div class="num-item-top">
        <div class="num-item-num">3.</div>
        <label ngx-dropzone [disabled]="showProgress" (change)="selected($event)" for="upload" class="styled-upload" [ngClass]="{'border-start': showStart, 'border-end': !showStart}">
          <ngx-dropzone-label *ngIf="!file" class="dropzone-label">
            <div class="d-flex align-items-center">
              <span class="icon"></span>
              <div class="dropzone-label-text">
                <span>{{'wizard.step-5.import' | translate}}</span>
                <span>{{'wizard.step-5.import-2' | translate}}</span>
              </div>
            </div>
          </ngx-dropzone-label>
          <ngx-dropzone-label *ngIf="file" class="dropzone-label">
            <div class="d-flex align-items-center">
              <span class="icon"></span>
              <div class="dropzone-label-text uploaded">
                <span>{{ "wizard.step-7.load-success"| translate }}</span>
                <span>{{this.file.name}}</span>
              </div>
            </div>
          </ngx-dropzone-label>
        </label>
      </div>
    </div>
    <div>
      <div *ngIf="showStart; then thenBlock else elseBlock"></div>
      <ng-template #thenBlock>
        <div class="num-item">
          <div class="num-item-top">
            <div class="num-item-num">4.</div>
            <p>
              {{'wizard.step-7.confirm-import' | translate}}
            </p>
          </div>
        </div>
      </ng-template>
      <ng-template #elseBlock>
        <div class="num-item">
          <div class="num-item-top">
            <div class="num-item-num">3.</div>
            <p>
              {{'wizard.step-7.result' | translate}}
            </p>
          </div>
          <div class="wiz-line-list">
            <div class="wiz-line-item"><span>{{'wizard.step-7.total-records' |
                translate}}</span><span>{{itemCount}}</span></div>
            <div class="wiz-line-item"><span>{{'wizard.step-7.ok-records' |
                translate}}</span><span>{{itemCount-errorList.length}}</span></div>
            <div class="wiz-line-item"><span>{{'wizard.step-7.not-ok-records' |
                translate}}</span><span [ngClass]="{'text-success': errorList.length === 0, 'text-danger': errorList.length > 0}">{{errorList.length}}</span></div>
          </div>
<!--          <div [ngClass]="{'wiz-import-btns': !showProgress}">-->
          <div class="wiz-import-btns">
            <div [ngClass]="{'w-50': errorList.length !== 0, 'w-100': errorList.length === 0}">
              <p-progressBar *ngIf="showProgress; else elseBlock" [color]="progressValue === itemCount - errorList.length ? '#49BEC9' : '#ED1C24'" [showValue]="false"
                [value]="progressValue/(itemCount-errorList.length)*100">
              </p-progressBar>
              <ng-container *ngIf="showProgress">{{progressValue}}/{{itemCount-errorList.length}}</ng-container>
              <div *ngIf="progressValue > 0 && progressValue === itemCount - errorList.length" class="mt-2" style="color: #49BEC9">{{'wizard.step-7.import-done' | translate}}</div>
            </div>
              <ng-template #elseBlock><button class="primary-btn" (click)="import()">{{'wizard.step-7.btn-import' |
                  translate}}</button></ng-template>
              <button *ngIf="errorList.length !== 0" class="red-link"
                (click)="showInvalidData()">{{'wizard.step-7.btn-show-not-ok-records' | translate}}</button>
          </div>
          <div *ngIf="showSkipMessage && errorList.length>0" class="skip-row-text">{{'wizard.step-7.not-ok-rows-omit' | translate}}</div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="wiz-footer">
    <button class="secondary-btn" routerLink="/plugplay/step-7/check"><i
        class="fas fa-chevron-left"></i><span>{{'wizard.step-7.btn-back' | translate}}</span></button>
    <button class="primary-btn" routerLink="/plugplay/step-7/result"><span>{{'wizard.step-7.btn-continue' |
        translate}}</span>
      <i class="fas fa-chevron-right"></i></button>
  </div>
</div>
